<template>
  <el-col :span="6" class="el-form-col">
    <el-form-item :label="label" :prop="prop">
      <slot>
        <template v-if="type === 'input'">
          <el-input
            :disabled="disabled"
            class="label-input"
            :value="value"
            :placeholder="placeholder"
            @input="val => $emit('input', val)"
            v-bind="inputAttr"
          ></el-input>
        </template>
        <template v-else>
          <el-autocomplete
            class="label-autocomplete"
            :value="value"
            @input="handleInput"
            @select="handleSelect"
            :trigger-on-focus="false"
            :fetch-suggestions="querySearch"
            :placeholder="placeholder"
            popper-class="label-autocomplete-popper"
            :disabled="disabled"
            v-bind="inputAttr"
          >
            <template #default="{ item }">
              <span class="autocomplete-item">{{ item[valueKey] }}</span>
            </template>
          </el-autocomplete>
        </template>
      </slot>
    </el-form-item>
  </el-col>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'labelInputForSupervision',
  props: {
    label: {
      type: String
    },
    labelWidth: {
      type: String,
      default: '80px'
    },
    labelAlign: {
      type: String,
      default: 'left' /* center left right justify */
    },
    querySearch: {
      type: Function,
      default: (queryString, cb) => {
        // 默认查询药店
        if (queryString.length > 1) {
          Fetch.getStoreList({ storeName: queryString, isDelete: 0 }).then(({ data }) => {
            cb(data);
          });
        } else {
          cb([]);
        }
      }
    },
    value: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'name'
    },
    type: {
      type: String,
      default: 'input'
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inputAttr: {
      type: Object
    },
    prop: {
      type: String
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    handleSelect(item) {
      this.$emit('input', item[this.valueKey]);
    }
  }
};
</script>

<style scoped lang="scss">
.el-form-col {
  /deep/.el-autocomplete {
    width: 100%;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-date-editor {
    width: 100%;
  }
  /deep/.el-input__inner:hover {
    border-color: #1e8dff !important;
  }
}
</style>
